import { Screen } from '~/screens/LegacyPendingUser';

export const LegacyPendingUser = () => <Screen />;
